import { ElectricStatus } from '../../constants/ElectricStatus';

const colors = {
	[ElectricStatus.ENERGIZED]: 'var(--pt-color-remote-on)',
	[ElectricStatus.DEENERGIZED]: 'var(--pt-color-black)',
	[ElectricStatus.DC_ENERGIZED]: 'var(--pt-color-blue)',
	[ElectricStatus.AC_ENERGIZED]: 'var(--pt-color-brown)'
};

export function injectPtElectricWireCSS() {
	const css = Object.entries(colors)
		.map(
			([status, color]) => `
      g.pt-electric-wire[data-status="${status}"] path {
        stroke: ${color};
        stroke-width: 1pt;
      }
    `
		)
		.join('\n');

	const style = document.createElement('style');
	style.textContent = css;
	document.head.appendChild(style);
}
